/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/whatsapp/mm_lite_api_status" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdWhatsappMmLiteApiStatus } from "./constants";
import type { WhatsAppMMLiteAPIStatusResponse } from "./types";

export const getEngagementAppGroupIdWhatsappMmLiteApiStatus = reactQueryFetcherAdapter(
  engagementAppGroupIdWhatsappMmLiteApiStatus,
  async (signal, appGroupId: string): Promise<WhatsAppMMLiteAPIStatusResponse> => {
    return await fetch(
      `/engagement/${appGroupId}/whatsapp/mm_lite_api_status`,
      "GET",
      undefined,
      {
        signal,
      },
      { propagateFetchRequestError: false }
    );
  }
);
